import { useTranslation } from 'react-i18next';

const HELP_HOTJAR_BASE_URL = 'https://help.hotjar.com/hc';

export const useHelpHotjarUrl = (): string => {
  const { i18n } = useTranslation();

  return `${HELP_HOTJAR_BASE_URL}/${i18n.resolvedLanguage?.toLowerCase() ?? 'en'}`;
};
